import { getBorderRadius } from '$lib/global/helper/border-radius';

export const setVideoBorderRadius = ({ wrapper }: { wrapper: HTMLDivElement }) => {
    if (wrapper) {
        const iframeElements = wrapper.getElementsByTagName('iframe');

        if (iframeElements.length !== 1) {
            return;
        }

        iframeElements[0].classList.add(getBorderRadius('video'));
    }
};
